(function () {
  'use strict';

  angular
    .module('crewSalesReport')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('crewSalesReport', {
        url: '/crew-sales-report',
        views : {
        	'crewSalesReportView' : {
        		templateUrl: 'crew-sales-report/views/crew-sales-report.tpl.html',
                controller: 'CrewSalesReportCtrl',
                controllerAs: 'crewSalesReport'
        	}
        }
      });
  }
}());
